export const loader = {
  namespaced: true,
  state: {
    isLoading: false,
    activeRequests: 0,
  },
  mutations: {
    START_LOADING(state) {
      state.activeRequests++;
      state.isLoading = true;
    },
    STOP_LOADING(state) {
      state.activeRequests = Math.max(0, state.activeRequests - 1);
      if (state.activeRequests === 0) {
        state.isLoading = false;
      }
    },
    RESET_LOADING(state) {
      state.activeRequests = 0;
      state.isLoading = false;
    }
  },
  actions: {
    startLoading({ commit }) {
      commit("START_LOADING");
    },
    stopLoading({ commit }) {
      commit("STOP_LOADING");
    },
    resetLoading({ commit }) {
      commit("RESET_LOADING");
    }
  },
  getters: {
    isLoading: (state) => state.isLoading,
  },
};
